import { render, staticRenderFns } from "./SecondPart.vue?vue&type=template&id=76b27030&scoped=true"
import script from "./SecondPart.vue?vue&type=script&lang=js"
export * from "./SecondPart.vue?vue&type=script&lang=js"
import style0 from "./secondPartCss/max.css?vue&type=style&index=0&id=76b27030&prod&scoped=true&lang=css&external"
import style1 from "./secondPartCss/middle.css?vue&type=style&index=1&id=76b27030&prod&scoped=true&lang=css&external"
import style2 from "./secondPartCss/flat.css?vue&type=style&index=2&id=76b27030&prod&scoped=true&lang=css&external"
import style3 from "./secondPartCss/min.css?vue&type=style&index=3&id=76b27030&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b27030",
  null
  
)

export default component.exports